var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZonaComercial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.582,
    height: 196.599,
    viewBox: "0 0 221.582 196.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002353;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    className: "cls-1",
    d: "M221.777,293.833a3.246,3.246,0,0,0-3.246,3.246v51.747h-66.9V287.394a7.582,7.582,0,0,0-7.574-7.574h-37.5a7.587,7.587,0,0,0-7.574,7.574v61.454h-66.9V297.079a3.246,3.246,0,0,0-6.492,0v53.262a4.981,4.981,0,0,0,4.977,4.977H220.046a4.981,4.981,0,0,0,4.977-4.977V297.079a3.242,3.242,0,0,0-3.246-3.246Zm-116.3,54.993V287.394a1.086,1.086,0,0,1,1.082-1.082h37.5a1.086,1.086,0,0,1,1.082,1.082v61.454Z",
    transform: "translate(-14.515 -158.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    className: "cls-1",
    d: "M381.565,345.074a6.924,6.924,0,0,0,6.924-6.924V302.744a6.924,6.924,0,0,0-6.924-6.924h-40.17a6.924,6.924,0,0,0-6.924,6.924v35.419a6.924,6.924,0,0,0,6.924,6.924Zm-40.59-6.924V302.744a.433.433,0,0,1,.433-.433h40.17a.433.433,0,0,1,.433.433v35.419a.433.433,0,0,1-.433.433H341.394a.433.433,0,0,1-.42-.433Z",
    transform: "translate(-189.719 -167.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    className: "cls-1",
    d: "M99.8,345.074a6.924,6.924,0,0,0,6.924-6.924V302.744A6.924,6.924,0,0,0,99.8,295.82H59.634a6.924,6.924,0,0,0-6.924,6.924v35.419a6.924,6.924,0,0,0,6.924,6.924ZM59.219,338.15V302.744a.433.433,0,0,1,.433-.433h40.17a.433.433,0,0,1,.433.433v35.419a.433.433,0,0,1-.433.433H59.634a.433.433,0,0,1-.415-.433Z",
    transform: "translate(-29.898 -167.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    className: "cls-1",
    d: "M212.061,47.852a6.3,6.3,0,0,1,6.275-6.306,3.246,3.246,0,0,0,3.246-3.246V30.377a3.246,3.246,0,0,0-3.246-3.246H164.754a3.246,3.246,0,0,0,0,6.492H215.09v1.865a12.815,12.815,0,0,0-9.119,9.114H154.9V15.792A15.809,15.809,0,0,0,139.116,0H82.47A15.809,15.809,0,0,0,66.678,15.792V27.131H3.246A3.246,3.246,0,0,0,0,30.377v7.941a3.246,3.246,0,0,0,3.246,3.229,6.3,6.3,0,0,1,6.275,6.306,3.242,3.242,0,0,0,1.549,2.77V72.793H5.245A4.981,4.981,0,0,0,.268,77.77V95.445a4.981,4.981,0,0,0,4.977,4.96h5.842V125.38a3.246,3.246,0,1,0,6.492,0V100.4H204.271v24.98a3.246,3.246,0,1,0,6.492,0V100.4h5.842a4.981,4.981,0,0,0,4.977-4.977V77.77a4.981,4.981,0,0,0-4.977-4.977h-5.842V50.436a3.237,3.237,0,0,0,1.3-2.584Zm-138.9-32.06a9.313,9.313,0,0,1,9.3-9.3h56.646a9.309,9.309,0,0,1,9.3,9.3V51.206a9.313,9.313,0,0,1-9.3,9.3H82.47a9.313,9.313,0,0,1-9.3-9.3V15.792ZM215.09,93.913H6.76V79.285H215.09ZM17.579,72.793V51.1H56.941a3.246,3.246,0,1,0,0-6.492H15.61a12.815,12.815,0,0,0-9.119-9.119V33.622H66.674V51.211A15.809,15.809,0,0,0,82.466,67h56.646A15.809,15.809,0,0,0,154.9,51.211V51.1h49.367v21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    className: "cls-1",
    d: "M219.342,359.54h-2.6a3.246,3.246,0,1,0,0,6.492h2.6a3.246,3.246,0,1,0,0-6.492Z",
    transform: "translate(-121.102 -203.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    className: "cls-1",
    d: "M198.026,36.439H202l4.081,19.505a8.223,8.223,0,0,0,8.032,6.526h19.276a8.249,8.249,0,0,0,7.677-5.306l6.366-16.852a5.219,5.219,0,0,0-4.882-7.063H215.289a3.246,3.246,0,0,0,0,6.492h25.417l-5.713,15.147a1.731,1.731,0,0,1-1.6,1.108H214.117a1.731,1.731,0,0,1-1.679-1.363l-4.1-19.583a6.422,6.422,0,0,0-6.262-5.089h-4.051a3.246,3.246,0,0,0,0,6.492Z",
    transform: "translate(-110.484 -16.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    className: "cls-1",
    d: "M235.361,111.38H234.5a3.246,3.246,0,1,0,0,6.492h.866a3.246,3.246,0,0,0,0-6.492Z",
    transform: "translate(-131.17 -63.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    className: "cls-1",
    d: "M267.861,111.38H267a3.246,3.246,0,0,0,0,6.492h.866a3.246,3.246,0,0,0,0-6.492Z",
    transform: "translate(-149.605 -63.177)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonaComercial);
export default __webpack_public_path__ + "static/media/ZonaComercial.4b75b32c52e39ee88e9c391c29eef6ba.svg";
export { ForwardRef as ReactComponent };